import React from 'react';
import styles from './AnimatedLogo.module.css';

const AnimatedLogo = ({ size = 'medium', showText = true }) => {
  return (
    <div className={`${styles.logoContainer} ${styles[size]}`}>
      <div className={styles.logoWrapper}>
        <img 
          src="/images/LOGOJPEG.png" 
          alt="CoF Logo" 
          className={styles.logo}
        />
        <div className={styles.pulseEffect}></div>
      </div>
      {showText && (
        <div className={styles.textContainer}>
          <h2 className={styles.mainText}>Concierge Of Football</h2>
          <div className={styles.underline}></div>
        </div>
      )}
    </div>
  );
};

export default AnimatedLogo; 